import { render, staticRenderFns } from "./yelo_general_tab.vue?vue&type=template&id=d8a45ada&scoped=true&"
import script from "./yelo_general_tab.vue?vue&type=script&lang=js&"
export * from "./yelo_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a45ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a45ada')) {
      api.createRecord('d8a45ada', component.options)
    } else {
      api.reload('d8a45ada', component.options)
    }
    module.hot.accept("./yelo_general_tab.vue?vue&type=template&id=d8a45ada&scoped=true&", function () {
      api.rerender('d8a45ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/yelo/location/tabs/yelo_general_tab.vue"
export default component.exports